import awards from "../../shared/la.awards";
import branded_quotes from "../../shared/la.branded-quotes";
import verticals from "./la-education-secondary.verticals";

const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "la-education-secondary-404":
            return {
                page,
                helmet: {
                    meta_title: "Sitio no encontrado | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://espanol.rosettastone.com/educacion-superior/404",
                    lang: "es"
                },
                ...pageFooter({ strings })
            };
        case "la-education-secondary-contact":
            return {
                page,
                helmet: {
                    meta_title: "Contacto | Rosetta Stone",
                    meta_description:
                        "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "xhttps://espanol.rosettastone.com/educacion-superior/contacto",
                    lang: "es"
                },
                ...pageFooter({ strings })
            };
        case "la-education-secondary-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "AAprendizaje de Idiomas en línea para educación superior | Rosetta Stone",
                    meta_description:
                        "Las soluciones de aprendizaje de idiomas de Rosetta Stone para educación superior proporcionan a los estudiantes acceso instantáneo en línea para que aprendan inglés y los idiomas del mundo. Pregunte sobre nuestros precios. ",
                    canonical_url: "https://espanol.rosettastone.com/educacion-superior/",
                    lang: "es"
                },
                ...pageFooter({ strings })
            };
        case "la-education-secondary-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "es"
                },
                ...pageFooter({ strings })
            };
        case "la-education-secondary-home":
            return {
                page,
                helmet: {
                    meta_title: "AAprendizaje de Idiomas en línea para educación superior | Rosetta Stone",
                    meta_description:
                        "Las soluciones de aprendizaje de idiomas de Rosetta Stone para educación superior proporcionan a los estudiantes acceso instantáneo en línea para que aprendan inglés y los idiomas del mundo. Pregunte sobre nuestros precios. ",
                    canonical_url: "https://espanol.rosettastone.com/educacion-superior/",
                    lang: "es"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
